import { liveEvents } from '../../../assets/js/application';
import $ from 'jquery';
import Vue from 'vue';
import SearchPanel from './searchPanel.vue';
import FavoritesPanel from './favoritesPanel.vue';

export async function initSearchResults(searchResults) {
    const events = await liveEvents();

    let el = searchResults.querySelector('[data-search-results-filters]');

    if (el) {
        new Vue({ el, components: { SearchPanel } });
    } else {
        el = searchResults.querySelector('[data-search-results-favorites]');

        if (el) {
            new Vue({ el, components: { FavoritesPanel } });
        }
    }

    events.addEventListener(
        '[data-search-agent-form]',
        'submit',
        async (event) => {
            const form = event.target,
                formAlert = event.target.querySelector('[data-form-alert]'),
                $nameInput = $('input[name="agent-name"]'),
                json = {};

            event.preventDefault();

            formAlert.hidden = true;

            if (form.dataset.loading === true || form.dataset.loading === 'true') {
                // just wait
                return;
            }

            let data = new FormData(form);

            for (const [name, value] of data) {
                json[name] = value;
            }

            try {
                event.target.dataset.loading = true;
                $nameInput.parsley().removeError('nameUsed', { updateClass: true });

                const response = await fetch(CONFIG.misc.registerSearchAgentEndpoint, {
                        method: 'post',
                        body: JSON.stringify(json),
                        headers: {
                            'Content-type': 'application/json',
                        },
                    }),
                    result = await response.json();

                event.target.dataset.loading = false;

                if (result.registered === true) {
                    const agent = form.closest('[data-search-agent]');

                    formAlert.innerText = '';
                    formAlert.hidden = true;

                    agent.querySelector('[data-step="1"]').classList.add('is-inactive');
                    agent.querySelector('[data-step="2"]').classList.remove('is-inactive');

                    agent.querySelector('[data-step="2"]').innerHTML = agent
                        .querySelector('[data-step="2"]')
                        .innerHTML.replace('%email%', json.email);
                } else if (result?.error === 'name_used') {
                    $nameInput
                        .parsley()
                        .addError('nameUsed', { message: 'Sie haben den selben Namen bereits in Verwendung' });
                } else if (result?.error.startsWith('search_registered')) {
                    const msg =
                        result.error === 'search_registered_verified'
                            ? 'Sie haben bereits einen aktiven Suchagenten für diese Suche eingestellt. Sie können gerne einen weiteren mit anderen Parametern erstellen.'
                            : 'Sie haben das letzte Mal den gleichen Suchagenten nicht aktiviert. Bitte bestätigen Sie die E-Mail, die Sie gerade von uns erhalten haben. Überprüfen Sie auch bitte Ihren Junk-/Spam-Ordner.';

                    formAlert.classList.remove('callout--alert');
                    formAlert.classList.add('callout--warning');
                    formAlert.innerText = msg;
                    formAlert.hidden = false;
                } else {
                    formAlert.classList.add('callout--alert');
                    formAlert.classList.remove('callout--warning');
                    formAlert.innerText = 'Etwas ist schief gelaufen. Bitte versuchen Sie es später noch einmal.';
                    formAlert.hidden = false;
                }
            } catch (e) {
                event.target.dataset.loading = false;
                formAlert.classList.add('callout--alert');
                formAlert.classList.remove('callout--warning');
                formAlert.innerText = 'Etwas ist schief gelaufen. Bitte versuchen Sie es später noch einmal.';
                formAlert.hidden = false;
            }
        },
        { passive: false },
        searchResults,
    );
}
